<template>
	<div class="rightMain">
		<div class="itemHeader">
			<h1>{{colname}}</h1>
		</div>
		<el-skeleton :rows="20" :loading="loadingMask" animated>
			<ul class="list5">
				<li v-for="(item,index) in moreDataList">
						<router-link :to="{ name: 'detail', params: { id: item.id }, query: { the : '1' , col : sourcecol }}"
											v-html="item.titleTagName+item.articletitle+'<i></i>'"  target="_blank" @click.native="$track([['pagetype','热点话题页-'+keyword+'-'+colname+'-文章-id:'+item.id+'-点击']])"
											:title="item.articletitle"></router-link>
						<p>{{item.summary}}</p>
						<em>{{item.updateTime.substring(0,10)}}</em>
				</li>
			</ul>
			<div class="pagediv">
				<el-pagination @size-change="changePageSize" @current-change="changeSearchPage"
					:current-page="pageNum" :page-sizes="[10, 20, 30]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="moreTotalCount">
				</el-pagination>
			</div>
		</el-skeleton>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: false,
				keyword: '',
				colid:'',
				pageNum: 1,
				pageSize: 10,
				moreTotalCount: '',
				moreDataList:[]
			}
		},
		props:[
			'colname',
			'sourcecol',
		],
		watch: {
			$route(to, from) {
				if ((to.params.pagetype=='3'||to.params.pagetype=='4')&&to.params.colid != from.params.colid) {
					this.keyword = this.$route.params.searchword;
					this.colid=this.$route.params.colid;
					this.pageNum = 1;
					this.getlistfnc();
				}
			}
		},
		mounted: function() {
			this.keyword = this.$route.params.searchword;
			this.colid=this.$route.params.colid;
			this.pageNum = 1;
			this.getlistfnc();
		},
		methods: {
			getlistfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'SearchInfo/getDEconThemeMoreAltList',
						responseType: 'json',
						params: {
							strKey: this.keyword,
							strType: this.$route.params.pagetype=='4'?'4':'5',
							ColID:this.colid,
							iPageNum: this.pageNum,
							iPageSize: this.pageSize,
							ColAlias: this.sourcecol,
						},
					})
					.then(function(response) {
						_this.moreDataList = response.data.data.data.tempResult.artLst;
						_this.moreTotalCount=response.data.data.data.tempResult.totalCount;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			changePageSize: function(pagesize) {
				this.pageSize = pagesize;
				this.getlistfnc();
			},
			changeSearchPage: function(page) {
				this.pageNum = page;
				this.getlistfnc();
				document.body.scrollTop = 0;
				document.documentElement.scrollTop = 0;
			},
		}
	}
</script>

<style>
</style>
